import axios from "axios";
import { config, SCHEDULE_IMPACT_API, SCHEDULES_API } from "./constGlobals";

/**
 * Una entrada del horario propuesto del empleado.
 * dayOfTheWeek sigue la convencion de horario de empleado: 1=Lunes .. 7=Domingo.
 */
export interface IScheduleRegistrationItem {
  id?: number | null;
  dayOfTheWeek: number;
  startTime: string; // "HH:MM"
  endTime: string; // "HH:MM"
  estado: number; // 1=activo
}

/** Una reserva afectada por el cambio de horario propuesto. */
export interface IAffectedReservation {
  reservationId: number;
  reservationDetailId: number;
  clientName: string;
  services: string[];
  dateTime: string;
  localName: string | null;
  status: string;
  /** Solo en la carga masiva: estilista dueño de la cita. */
  employeeId?: number;
  employeeName?: string;
}

/** Respuesta del endpoint de preview de impacto de horario. */
export interface IScheduleImpactResponse {
  isSuccess: boolean;
  status: number;
  message: string;
  data: {
    affectedCount: number;
    affected: IAffectedReservation[];
  };
}

const toImpactResponse = (response: any): IScheduleImpactResponse => ({
  isSuccess: true,
  status: response.data?.status || response.status,
  message: response.data?.message || "",
  data: {
    affectedCount: response.data?.data?.affectedCount ?? 0,
    affected: response.data?.data?.affected ?? [],
  },
});

const toImpactError = (error: any): IScheduleImpactResponse => ({
  isSuccess: false,
  status: error?.response?.status || 500,
  message:
    error?.response?.data?.message ||
    "No se pudo calcular el impacto del cambio de horario.",
  data: { affectedCount: 0, affected: [] },
});

/**
 * US2 spec 016 — Previsualiza (sin persistir) las reservas que quedarian fuera
 * del horario propuesto para el empleado.
 *
 * POST /api/v2/employees/:id/schedule-impact
 */
export const getScheduleImpact = async (
  idEmployee: number,
  scheduleRegistration: IScheduleRegistrationItem[]
): Promise<IScheduleImpactResponse> => {
  const url = SCHEDULE_IMPACT_API(idEmployee);
  try {
    const response = await axios.post(url, { scheduleRegistration }, config);
    return toImpactResponse(response);
  } catch (error) {
    return toImpactError(error);
  }
};

/**
 * Spec 016 (#9) — Previsualiza (sin persistir) las reservas que quedarian
 * fuera del horario si se elimina la franja guardada `idSchedule`.
 *
 * POST /api/v2/employees/schedules/delete-impact
 */
export const getDeleteScheduleImpact = async (
  idSchedule: number
): Promise<IScheduleImpactResponse> => {
  try {
    const response = await axios.post(
      `${SCHEDULES_API}/delete-impact`,
      { id: idSchedule },
      config
    );
    return toImpactResponse(response);
  } catch (error) {
    return toImpactError(error);
  }
};
